<template>
  <div class="modal-content fm-modal-audio-player">
    <div class="modal-header">
      <h5 class="modal-title w-75 text-truncate">
        ورود به اینستاگرام
        <small class="text-muted pl-3"></small>
      </h5>
      <button type="button" aria-label="Close" @click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <template v-if="state === 'login'">
      <div class="modal-body">
        <form class="form" novalidate="novalidate" id="login_form">
          <div class="text-left mb-5">
            <small>- گذرواژه شما در سامانه ما ذخیره نمی‌شود.</small>
            <br />
            <small>
              -  ورود دو مرحله ای صفحه شما باید غیرفعال باشد
            </small>
          </div>
          <div class="input-icon" dir="ltr">
            <input
              :type="[showPassword ? 'text' : 'password']"
              class="form-control"
              placeholder="Password"
              v-model="password"
              autocomplete="off"
              readonly
              onfocus="this.removeAttribute('readonly');"
            />
            <span @click="showPassword = !showPassword">
              <i
                class="fad icon-md cursor-pointer"
                :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"
              ></i
            ></span>
          </div>

          <div class="d-flex justify-content-end mt-6">
            <span class="d-block">
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click="hideModal"
              >
                انصراف
              </button>
              <button
                type="button"
                class="btn btn-sm btn-primary ml-3"
                ref="login_submit"
                @click="login"
              >
                ورود
              </button>
            </span>
          </div>
        </form>
      </div>
    </template>
    <template v-if="state === '2fa'">
      <div class="modal-body">
        <form class="form" novalidate="novalidate" id="2fa_form">
          <input
            type="text"
            class="form-control"
            placeholder="کد ارسال شده"
            v-model="code"
            autocomplete="off"
            dir="ltr"
          />

          <div class="d-flex justify-content-end mt-6">
            <span class="d-block">
              <button
                type="submit"
                class="btn btn-sm btn-primary ml-3"
                ref="2fa_submit"
                @click="tfa"
              >
                ارسال
              </button>
            </span>
          </div>
        </form>
      </div>
    </template>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "InstagramLoginForm",
  data() {
    return {
      state: "login",
      showPassword: false,
      password: "",
      code: ""
    };
  },
  props: {
    data: Object
  },
  mounted() {
    this.state = "login";
  },
  beforeDestroy() {},
  methods: {
    login() {
      const submitButton = this.$refs["login_submit"];
      this.disableBtn(submitButton);

      ApiService.post(`destinations/${this.data.id}/login`, {
        password: this.password
      })
        .then(({ data }) => {
          this.enableBtn(submitButton);

          if (data["2fa"] === true) {
            this.state = "2fa";
          } else {
            this.hideModal();
            this.showMessage("ورود موفق به اینستاگرام");
          }
        })
        .catch(() => {
          this.enableBtn(submitButton);
          this.hideModal();
        });
    },
    tfa() {
      let code = this.parseNumbers(this.code);

      const submitButton = this.$refs["2fa_submit"];
      this.disableBtn(submitButton);

      ApiService.post(`destinations/${this.data.id}/2fa`, {
        code: code
      })
        .then(() => {
          this.enableBtn(submitButton);
          this.hideModal();
          this.showMessage("ورود موفق به اینستاگرام");
        })
        .catch(() => {
          this.enableBtn(submitButton);
          this.hideModal();
        });
    }
  }
};
</script>
